import { Button, Modal, Alert, Row, Card, Col, Spinner } from "react-bootstrap";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { BsX } from "react-icons/bs";
import { AgGridReact } from "ag-grid-react";
import { useRef, useState, useEffect, useMemo, useContext } from "react";
import { getActiveRoles } from "../../services/role-service";
import GolbalSearch from "./GolbalSearch";
import { getAllUsers, getHRISActiveUsers } from "../../services/user-service";
import Pagination from "../utils/Pagination";
import "../masters/GridMaster.css";
import { AuthContext } from "../../contexts/AuthContext";
import { formatDateDD_MM_YYYY } from "../../functions/common-functions";
import { addLogDetails } from "../../services/logger-entry-service";
import { getActiveCustomers } from "../../services/customer-service";
import { getItems } from "../../services/item-master-service";
import { getAllContracts } from "../../services/contract-master-service";
import { getAllLocations, getAllLocationForDivision } from "../../services/location-master-service";
import { getValidUserData } from "../../services/user-service";

const SingleValuePopUp = (props) => {
  const gridRef = useRef();
  const [columnDefs, setColumnDefs] = useState([]);
  const [rowData, setRowData] = useState(null);
  const [filteredCol, setFilteredCol] = useState([]);
  const [globalText, setGlobalText] = useState("");
  const [filteredResult, setFilteredResult] = useState([]);
  const [cardData, setCardData] = useState([]);
  const [selectedCard, setSelectedCard] = useState();
  const [alertMessage, setAlertMessage] = useState("");
  const context = useContext(AuthContext);
  const userDetails = { dataControl: context.dataControl, userId: context.userId, userName: context.userName, role: context.role }
  const [pageSize] = useState(3);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);

  let showAddBtn = props.hasOwnProperty("showAddBtn") ? props.showAddBtn : true;

  // const getMaskingInd = async () => {
  //   let rolesData = await getRolesForUnmaskedData().catch((err) => { console.log(err) });
  //   let ismasking = true;
  //   if (rolesData.length > 0) {
  //     let showMaskedDataInd = rolesData[0].RoleCode.trim().split(",").indexOf(userDetails.role);
  //     if (showMaskedDataInd !== -1) {
  //       ismasking = false;
  //     }
  //   }
  //   return ismasking;
  // }

  const fetchData = async () => {
    setLoading(true);
    switch (mastername) {
      case "Role Master": {
        const result = await getActiveRoles();
        setRowData(result);
        setFilteredResult(result);
        setCardData(result);
      }
        break;
      case "HRIS Details": {
        const result = await getHRISActiveUsers();
        setRowData(result);
        setFilteredResult(result);
        setCardData(result);
      }
        break;
      case "Customer Master": {
        let allItems = [];
        let lastKey = null;
        let batchCount = 0;
        do {
          
          const response = await getActiveCustomers(2000, lastKey);
          allItems = [...allItems, ...(response.items || [])];
          lastKey = response.lastEvaluatedKey;
        } while (lastKey);
        setRowData(allItems);
        setFilteredResult(allItems);
        setCardData(allItems);
      }
        break;
      case "Item Master": {
        let allItems = [];
        let lastKey = null;
        let batchCount = 0;
        do {
            batchCount++;
          console.log(`📦 Fetching batch....${batchCount}`);
          const response = await getItems(2000, lastKey);
          allItems = [...allItems, ...(response.items || [])];
          lastKey = response.lastEvaluatedKey;
          console.log(`✅ Batch ${batchCount} loaded: ${response.items.length} records (Total: ${allItems.length})`);
          console.log(lastKey);
        } while (lastKey);
        console.log(`🎉 All data loaded: ${allItems.length} total records`);
        setRowData(allItems);
        setFilteredResult(allItems);
        setCardData(allItems);
      }
        break;
      case "Contract Master": {
        const allContracts = await getAllContracts();
        const result = allContracts.filter(c => c.DeleteIndication === "Active");
        setRowData(result);
        setFilteredResult(result);
        setCardData(result);
      }
        break;
      case "User Master": {
        const result = await getAllUsers();
        setRowData(result);
        setFilteredResult(result);
        setCardData(result);
      }
        break;
      case "Location Master": {
        let result;
        if (arr.length > 2 && arr[1] === "USER") {
          const userData = await getValidUserData("UserMaster", "UserId", arr[2]);
          const userLocations = userData[0].Location?.split(",").map(item => item.trim());
          result = userLocations.map(location => ({
            LocationCode: userLocations.indexOf(location),
            Location: location,
            Division: userData[0].Division,
            DeleteIndication: "Active"
          }));
        } else if (arr.length > 2 && arr[1] === "DIVISION") {
          result = await getAllLocationForDivision(arr[2]);
        } else if (arr.length > 1 && arr[1]) {
          result = await getAllLocationForDivision(arr[1]);
        } else {
          result = await getAllLocations();
        }
        setRowData(result);
        setFilteredResult(result);
        setCardData(result);
      }
        break;
    }
    setLoading(false);
  };
  let arr = props.mastername.split(":");
  let mastername = arr[0];

  const generateColumnDefs = async () => {
    switch (mastername) {
      case "Role Master":
        {
          let colDef = [
            {
              field: "",
              width: 50,
              cellRenderer: radioCellRenderer,
            },
            {
              field: "RoleCode",
              headerName: "Role Code",
              tooltipField: "RoleCode",
            },
            {
              field: "RoleDescription",
              headerName: "Role Description",
              tooltipField: "RoleDescription",
            },
          ];
          setColumnDefs(colDef);
        }
        break;
      case "HRIS Details":
        {
          let colDef = [
            {
              field: "",
              width: 50,
              cellRenderer: radioCellRenderer,
            },
            {
              headerName: "Status",
              field: "DeleteIndication",
              flex: false,
              width: 120,
              resizable: false,
              tooltipField: "DeleteIndication",
            },
            {
              field: "EmpEmailId",
              headerName: "User ID",
              tooltipField: "EmpEmailId",
            },
            {
              field: "EmpShortName",
              headerName: "User Name",
              tooltipField: "EmpShortName",
            },
            {
              field: "EmpDivision",
              headerName: "HRIS Division",
              tooltipField: "EmpDivision",
            },
          ];
          setColumnDefs(colDef);
        }
        break;
      case "Customer Master":
        {
          let colDef = [
            {
              field: "",
              width: 50,
              cellRenderer: radioCellRenderer,
            },
            {
              field: "CustomerCode",
              headerName: "BP Code",
              tooltipField: "CustomerCode",
            },
            {
              field: "CustomerName",
              headerName: "Customer Name",
              tooltipField: "CustomerName",
            }
          ];
          setColumnDefs(colDef);
        }
        break;
      case "Item Master":
        {
          let colDef = [
            {
              field: "",
              width: 50,
              cellRenderer: radioCellRenderer,
            },
            {
              headerName: "Item Code",
              field: "ItemCode",
              tooltipField: "ItemCode",
            },
            {
              field: "ItemDescription",
              headerName: "Item Description",
              tooltipField: "ItemDescription",
            },
            {
              field: "ItemType",
              headerName: "Item Type",
              tooltipField: "ItemType",
            },
            {
              field: "ProductClass",
              headerName: "Product Class",
              tooltipField: "ProductClass",
            },
            {
              field: "CommodityCodes",
              headerName: "Commodity Code",
              tooltipField: "CommodityCodes",
            },
            {
              field: "LogisticCompany",
              headerName: "Logistic Company",
              tooltipField: "LogisticCompany",
            }
          ];
          setColumnDefs(colDef);
        }
        break;
      case "Contract Master":
        {
          let colDef = [
            {
              field: "",
              width: 50,
              cellRenderer: radioCellRenderer,
            },
            {
              headerName: "Contract Period(Months)",
              field: "ContractPeriod",
              tooltipField: "ContractPeriod",
            },
            {
              field: "ItemCode",
              headerName: "Item Code",
              tooltipField: "ItemCode",
            },
            {
              field: "ItemDescription",
              headerName: "Item Description",
              tooltipField: "ItemDescription",
            },
            {
              field: "ItemDetail",
              headerName: "Item Detail",
              tooltipField: "ItemDetail",
            },
            {
              field: "Location",
              headerName: "Location",
              tooltipField: "Location",
            },
            {
              field: "GSTRate",
              headerName: "GST Rate",
              tooltipField: "GSTRate",
            }
          ];
          setColumnDefs(colDef);
        }
        break;
      case "User Master":
        {
          let colDef = [
            {
              field: "",
              width: 50,
              cellRenderer: radioCellRenderer,
            },
            {
              headerName: "Status",
              field: "DeleteIndication",
              flex: false,
              width: 120,
              resizable: false,
              tooltipField: "DeleteIndication",
            },
            {
              field: "UserId",
              headerName: "User ID",
              tooltipField: "UserId",
            },
            {
              field: "UserName",
              headerName: "User Name",
              tooltipField: "UserName",
            },
            {
              field: "UserType",
              headerName: "User Type",
              tooltipField: "UserType",
            },
            {
              field: "Division",
              headerName: "Division",
              tooltipField: "Division",
            },
          ];
          setColumnDefs(colDef);
        }
        break;
      case "Location Master":
        {
          let colDef = [
            {
              field: "",
              width: 50,
              cellRenderer: radioCellRenderer,
            },
            {
              headerName: "Status",
              field: "DeleteIndication",
              flex: false,
              width: 165,
              resizable: false,
              tooltipField: "DeleteIndication",
            },
            {
              field: "Location",
              headerName: "Location",
              tooltipField: "Location",
              width: 270,
            },
            {
              field: "Division",
              headerName: "Division",
              tooltipField: "Division",
              width: 270,
            },
          ];
          setColumnDefs(colDef);
        }
        break;

    }
    fetchData();
  }

  useEffect(() => {
    generateColumnDefs();
  }, []);

  const radioCellRenderer = (params) => {
    let cellValue = (
      <div className="radio-item">
        <input
          name="selection"
          type="radio"
          id={`selection${params.node.rowIndex}`}
          defaultChecked={
            params.data[props.paramkey] === props.paramvalue
              ? true
              : false
          }
        ></input>
      </div>
    );
    params.data[props.paramkey] === props.paramvalue
      ? params.node.setSelected(true)
      : params.node.setSelected(false);
    return cellValue;
  };

  const defaultColDef = {
    resizable: true,
    suppressMovable: true,
    filter: true,
    sortable: true,
    filterParams: {
      buttons: ["reset", "apply"],
      closeOnApply: true,
      defaultJoinOperator: "OR",
    },
  };

  const assignData = async () => {
    let selectedRows = gridRef.current.api.getSelectedRows();
    let selectedRowsCount = gridRef.current.api.getSelectedRows().length;
    if (selectedRowsCount > 0) {
      if (mastername === "HRIS Details") {
        await addLogDetails(selectedRows[0], "View", "SK#" + selectedRows[0].SK, "SinglePopUpLog", userDetails, "Master");
      }
      props.setSelected({ name: props.mastername, result: selectedRows[0], key: props.paramvalue, value: props.additionalParams });
      props.onHide();
    } else
      setAlertMessage(
        "Please select a record before clicking on Assign button."
      );
  };

  const assignCustomData = async () => {
    let selectedRows = selectedCard;
    if (selectedRows !== undefined) {
      if (mastername === "HRIS Details") {
        await addLogDetails(selectedRows, "View", "SK#" + selectedRows.SK, "SinglePopUpLog", userDetails, "Master");
      }
      props.setSelected({ name: props.mastername, result: selectedRows, key: props.paramvalue, value: props.additionalParams });
      props.onHide();
    }
    else {
      setAlertMessage(
        "Please select a record before clicking on Assign button."
      );
    }
  };

  const onGridReady = () => {
    gridRef.current.api.sizeColumnsToFit();
  };

  const handleRadioSelection = () => {
    if (showAddBtn) {
      let nodeEl = gridRef.current.api.getSelectedNodes();
      let node = document.getElementById(`selection${nodeEl[0].rowIndex}`);
      node.checked = true;
    }
  };

  const handleGlobalSearch = (text) => {
    let searchText = text.toLowerCase();
    setGlobalText(searchText);
    let arr = props.mastername.split(":");
    let mastername = arr[0];
    if (searchText) {
      let result = rowData ? rowData.filter((item) => {
        switch (mastername) {
          case "Role Master":
            return (
              item.RoleCode?.toString().toLowerCase().indexOf(searchText) >= 0 ||
              item.RoleDescription?.toLowerCase().indexOf(searchText) >= 0
            );
          case "HRIS Details":
            return (
              item.EmpEmailId.toString().toLowerCase().indexOf(searchText) >= 0 ||
              item.EmpShortName.toString().toLowerCase().indexOf(searchText) >= 0 ||
              item.EmpDivision.toString().toLowerCase().indexOf(searchText) >= 0
            );
          case "Customer Master":
            return (
              item.CustomerCode?.toString().toLowerCase().indexOf(searchText) >= 0 ||
              item.CustomerName?.toString().toLowerCase().indexOf(searchText) >= 0
            );
          case "Item Master":
            return (
              item.ItemCode?.toString().toLowerCase().indexOf(searchText) >= 0 ||
              item.ItemDescription?.toLowerCase().indexOf(searchText) >= 0 ||
              item.ItemType?.toLowerCase().indexOf(searchText) >= 0 ||
              item.ProductClass?.toLowerCase().indexOf(searchText) >= 0 ||
              item.CommodityCodes?.toString().toLowerCase().indexOf(searchText) >= 0 ||
              item.LogisticCompany?.toLowerCase().indexOf(searchText) >= 0
            );
          case "Contract Master":
            return (
              item.ItemCode?.toString().toLowerCase().indexOf(searchText) >= 0 ||
              item.ItemDescription?.toLowerCase().indexOf(searchText) >= 0 ||
              item.ItemDetail?.toLowerCase().indexOf(searchText) >= 0 ||
              item.ContractPeriod?.toString().toLowerCase().indexOf(searchText) >= 0 ||
              item.Location?.toString().toLowerCase().indexOf(searchText) >= 0 ||
              item.GSTRate?.toString().toLowerCase().indexOf(searchText) >= 0
            );
          case "User Master":
            return (
              item.UserId?.toString().toLowerCase().indexOf(searchText) >= 0 ||
              item.UserName?.toString().toLowerCase().indexOf(searchText) >= 0 ||
              item.UserType?.toString().toLowerCase().indexOf(searchText) >= 0 ||
              item.Division?.toString().toLowerCase().indexOf(searchText) >= 0
            );
          case "Location Master":
            return (
              item.DeleteIndication?.toString().toLowerCase().indexOf(searchText) >= 0 ||
              item.Location?.toString().toLowerCase().indexOf(searchText) >= 0 ||
              item.Division?.toString().toLowerCase().indexOf(searchText) >= 0
            );
        }
      }) : null;
      setFilteredResult(result);
      setCardData(result);
    } else {
      setFilteredResult(rowData);
      setCardData(rowData);
    }
  };

  const resetAllFilter = () => {
    gridRef.current.api.setFilterModel(null);
  };

  function resetFilter(item) {
    let item1 = item.substring(0, item.indexOf(":") - 1);

    let col = gridRef.current.api.getFilterModel();
    for (const key of Object.keys(col)) {
      if (key === feildName(item1)) {
        delete col[key];
      }
    }
    gridRef.current.api.setFilterModel(col);
  }

  const headerName = (field) => {
    let name;
    switch (field) {
      case "DeleteIndication":
        name = "Status";
        break
      case "RoleCode":
        name = "Role Code";
        break;
      case "RoleDescription":
        name = "Role Description";
        break;
      case "EmpEmailId":
        name = "User ID";
        break;
      case "EmailId":
        name = "Email Id";
        break;
      case "EmpShortName":
        name = "User Name";
        break;
      case "EmpDivision":
        name = "HRIS Division";
        break;
      case "ItemCode":
        name = "Item Code";
        break;
      case "ItemDescription":
        name = "Item Description";
        break;
      case "ItemType":
        name = "Item Type";
        break;
      case "ProductClass":
        name = "Product Class";
        break;
      case "CommodityCodes":
        name = "Commodity Code";
        break;
      case "LogisticCompany":
        name = "Logistic Company";
        break;
      case "GSTRate":
        name = "GST Rate";
        break;
      case "Location":
        name = "Location";
        break;
      case "UserId":
        name = "User ID";
        break;
      case "UserName":
        name = "User Name";
        break;
      case "UserType":
        name = "User Type";
        break;
      case "Division":
        name = "Division";
        break;
      default:
        name = "No match found";
        break;
    }
    return name;
  };

  const feildName = (header) => {
    let name;
    switch (header) {
      // Project Master
      case "DeleteIndication":
        name = "Status";
        break
      case "Role Code":
        name = "RoleCode";
        break;
      case "Role Description":
        name = "RoleDescription";
        break;
      case "HRIS User ID":
        name = "EmpEmailId";
        break;
      case "Email Id":
        name = "EmailId";
        break;
      case "HRIS User Name":
        name = "EmpShortName";
        break;
      case "HRIS Division":
        name = "EmpDivision";
        break;
      case "Item Code":
        name = "ItemCode";
        break;
      case "Item Description":
        name = "ItemDescription";
        break;
      case "Item Type":
        name = "ItemType";
        break;
      case "Product Class":
        name = "ProductClass";
        break;
      case "Commodity Code":
        name = "CommodityCodes";
        break;
      case "Logistic Company":
        name = "LogisticCompany";
        break;
      case "GST Rate":
        name = "GSTRate";
        break;
      case "Location":
        name = "Location";
        break;
      case "User ID":
        name = "UserId";
        break;
      case "User Name":
        name = "UserName";
        break;
      case "User Type":
        name = "UserType";
        break;
      case "Division":
        name = "Division";
        break;
      default:
        name = "No match found";
        break;
    }
    return name;
  };

  const onFilterChanged = (param) => {
    let a = document.getElementById("filterDisplayPop");
    setFilteredCol([]);
    let col = param.api.getFilterModel();

    if (Object.keys(col).length === 0) {
      a.classList.add("d-none");
    } else {
      a.classList.remove("d-none");
      for (const key of Object.keys(col)) {
        let filter;
        if (col[key].filterType === "date") {
          if (col[key].condition1) {
            let fromDate1 = col[key].condition1.dateFrom
              ? formatDateDD_MM_YYYY(col[key].condition1.dateFrom)
              : col[key].condition1.dateFrom;
            let toDate1 = col[key].condition1.dateTo
              ? formatDateDD_MM_YYYY(col[key].condition1.dateTo)
              : col[key].condition1.dateTo;
            let fromDate2 = col[key].condition2.dateFrom
              ? formatDateDD_MM_YYYY(col[key].condition2.dateFrom)
              : col[key].condition2.dateFrom;
            let toDate2 = col[key].condition2.dateTo
              ? formatDateDD_MM_YYYY(col[key].condition2.dateTo)
              : col[key].condition2.dateTo;
            filter =
              headerName(key) +
              " : " +
              fromDate1 +
              (toDate1 ? " To " + toDate1 : "") +
              ", " +
              fromDate2 +
              (toDate2 ? " To " + toDate2 : "");
            console.log("true date");
          } else {
            filter =
              headerName(key) +
              " : " +
              col[key].dateFrom?.substring(0, 10) +
              (col[key].dateTo ? " To " + col[key].dateTo?.substring(0, 10) : "");
            console.log("false date", col[key].dateFrom?.substring(0, 10));
          }
        }
        else if (col[key].filterType === "number") {
          if (col[key].condition1) {
            filter =
              headerName(key) +
              " : " +
              col[key].condition1.filter +
              (col[key].condition1.filterTo
                ? " To " + col[key].condition1.filterTo
                : "") +
              ", " +
              col[key].condition2.filter +
              (col[key].condition2.filterTo
                ? " To " + col[key].condition2.filterTo
                : "");
          } else {
            filter =
              headerName(key) +
              " : " +
              col[key].filter +
              (col[key].filterTo ? " To " + col[key].filterTo : "");
          }
        }
        else {
          if (col[key].condition1) {
            filter =
              headerName(key) +
              " : " +
              col[key].condition1.filter +
              ", " +
              col[key].condition2.filter;
          } else {
            filter = headerName(key) + " : " + col[key].filter;
          }
        }
        setFilteredCol((prev) => {
          return [...prev, filter];
        });
      }
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setAlertMessage("");
    }, 10000);
    return () => clearTimeout(timer);
  }, [alertMessage]);

  const filteredResult1 = useMemo(() => {
    if (!Array.isArray(cardData)) return [];
    
    let firstPageIndex = 0;
    if (currentPage > 1) {
      firstPageIndex = (currentPage - 1) * pageSize;
    }
    if (firstPageIndex >= cardData.length) {
      firstPageIndex = 0;
      const totalPageCount = Math.ceil(cardData.length / pageSize);
      if (totalPageCount > 0) {
        setCurrentPage(totalPageCount)
      } else {
        setCurrentPage(1)
      }
    }
    let lastPageIndex = parseInt(firstPageIndex) + parseInt(pageSize);
    return cardData.slice(firstPageIndex, lastPageIndex);
  }, [currentPage, cardData, pageSize]);

  return (
    <>
      {loading && <div className="spinner-box"> <Spinner animation="border" className="spinner" /></div>}
      <Modal {...props} size="lg" backdrop="static" centered>
        <Modal.Header closeButton>
          <Modal.Title style={{ fontFamily: "G&B-BodyCopy" }}>
            {props.additionalParams?.popupTopMasterName
              ? props.additionalParams.popupTopMasterName
              : props.mastername.split(":")[0]}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <Row>
              <div className="global-search-container">
                <GolbalSearch filterFunc={handleGlobalSearch} />
              </div>
              <div
                className="d-none mt-3 d-flex"
                id="filterDisplayPop"
                style={{ gap: "8px" }}
              >
                {filteredCol &&
                  filteredCol.map((item, index) => {
                    return (
                      <div className="filter-col pr-0  me-2" key={index}>
                        <span className="ps-2 btn-text">{item}</span>
                        <div onClick={() => resetFilter(item)}>
                          <BsX size={32} />
                        </div>
                      </div>
                    );
                  })}
                <Button
                  variant="outline-primary"
                  className="ms-2 lh-1 clear-all-btn"
                  onClick={resetAllFilter}
                >
                  Clear All
                </Button>
              </div>
            </Row>
            <div className="ag-theme-alpine d-none d-md-block d-lg-block">
              <AgGridReact
                ref={gridRef}
                rowData={filteredResult}
                columnDefs={columnDefs}
                rowSelection={"single"}
                defaultColDef={defaultColDef}
                onGridReady={onGridReady}
                headerHeight={40}
                rowHeight={40}
                pagination={true}
                paginationPageSize={5}
                onSelectionChanged={handleRadioSelection}
                onFilterChanged={onFilterChanged}
                enableBrowserTooltips={true}
                domLayout="autoHeight"
              ></AgGridReact>
            </div>
            <div className="market-wrapper d-md-none d-lg-none table-container1">
              {
                filteredResult1.map((selection, index) =>
                  <Card key={index} className="cardContainer">
                    <Card.Body className="cardbodycontainerResponsive">
                      {
                        showAddBtn &&
                        <Col> <div className="radio-item">
                          <input
                            name="selection"
                            type="radio"
                            onChange={() => setSelectedCard(selection)}
                            id={`selection${index}`}
                          ></input>
                        </div></Col>
                      }
                      {columnDefs.map((header) => {
                        let formattedValue = header.field && header.field !== "" && header.valueFormatter ? header.valueFormatter({ "data": selection, "colDef": { field: header.field }, "node": { "rowIndex": index }, "value": selection[header.field] }) : selection[header.field];
                        let displayValue = header.field && header.field !== "" && header.cellRenderer ? header.cellRenderer({ "data": selection, "colDef": { field: header.field }, "node": { "rowIndex": index }, "value": selection[header.field] }) : formattedValue;
                        return (header.field && header.field !== "" &&
                          <Row key={header.field + "" + index} className="responsive-row">
                            <Col className="colHeader">{header.headerName}</Col>
                            <Col className="colData">{displayValue}</Col>
                          </Row>
                        )
                      }
                      )}
                    </Card.Body>
                  </Card>
                )}
              <Pagination
                currentPage={currentPage}
                totalCount={cardData ? cardData.length : 0}
                data={cardData}
                pageSize={pageSize}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
          </div>
        </Modal.Body>
        {alertMessage && (
          <Alert variant="light">
            {alertMessage}
          </Alert>
        )}

        <Modal.Footer>
          {
            showAddBtn &&
            <>
              <Button variant="success"
                className="float-end me-2 d-none d-md-block d-lg-block greenButton"
                onClick={assignData}
              >
                Add
              </Button>
              <Button variant="success"
                className="float-end me-2 d-md-none d-lg-none greenButton"
                onClick={assignCustomData}
              >
                Assign
              </Button>
              {/* <Button
            size="sm"
            className="float-start me-2"
            variant="outline-primary"
            onClick={() => props.onHide()}
          >
            Cancel
          </Button> */}
            </>
          }
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SingleValuePopUp;
